document.addEventListener("DOMContentLoaded", event => {

  function headerspace() {
    const header = document.querySelector(".site-header");
    const announceBar = document.querySelector(".announcement-bar");

    const headerHeight = header ? header.offsetHeight : 0;
    const announceHeight = announceBar ? announceBar.offsetHeight : 0;
    const totalHeight = headerHeight + announceHeight;

    document.querySelectorAll(".site-header").forEach(el => {
      el.style.top = announceHeight + "px";
    });
    document.querySelectorAll(".main-wrapper").forEach(el => {
      el.style.paddingTop = totalHeight + "px";
    });

    document.querySelectorAll(".service-form-progress-header").forEach(el => {
      el.style.top = headerHeight + "px";
    });
  }

  headerspace();

  ["resize", "load", "scroll", "orientationchange"].forEach(event => {
    window.addEventListener(event, headerspace);
  });

  document.body.addEventListener("click", function (e) {
    if (window.innerWidth < 1024) {
      const btn = e.target.closest(".menu-bars");
      const closeBtn = e.target.closest(".main-menu .close-icon");

      if (btn) {
        e.preventDefault();
        btn.classList.add("active"); 

        document.querySelectorAll(".main-menu").forEach(el => {
          el.classList.add("open"); 
        });
        document.body.classList.add("overflow-hidden");
      }

      if (closeBtn) {
        e.preventDefault();

        const menuBarsBtn = document.querySelector(".menu-bars");
        if (menuBarsBtn) {
          menuBarsBtn.classList.remove("active");
        }

        document.querySelectorAll(".main-menu").forEach(el => {
          el.classList.remove("open"); 
        });

        document.body.classList.remove("overflow-hidden");
      }
    }
  });

  const accordions = document.querySelectorAll("[data-accordion-title]");
  accordions.forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
      e.stopPropagation();

      const isActive = accordion.classList.contains("active");
      const group = accordion.closest("[data-accordion]");

      group.querySelectorAll(":scope > [data-accordion-title]").forEach((item) => {
        item.classList.remove("active");
        if (item.nextElementSibling) {
          item.nextElementSibling.style.maxHeight = null;
        }
      });

      group.parentElement.querySelectorAll("[data-accordion-title]").forEach((item) => {
        item.classList.remove("active");
        if (item.nextElementSibling) {
          item.nextElementSibling.style.maxHeight = null;
        }
      });

      if (!isActive) {
        accordion.classList.add("active");
        if (accordion.nextElementSibling) {
          accordion.nextElementSibling.style.maxHeight =
          accordion.nextElementSibling.scrollHeight + "px";
        }
      }
    });
  });
});
if (document.querySelector('.page-template')) {
  var recommended_swiper = new Swiper(".testimonial-carousel", {
    slidesPerView: 3.5,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
      // autoplay: {
      // 	delay: 2500,
      // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1281: {
        slidesPerView: 3.5,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 2.5,
        centeredSlides: false,
      },
      769: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      576: {
        slidesPerView: 1.5,
        centeredSlides: false,
      },
      319: {
        centeredSlides: false,
        slidesPerView: 1.1,
      },
    }
  });
} else {
  var recommended_swiper = new Swiper(".testimonial-carousel", {
    slidesPerView: 4,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
      // autoplay: {
      // 	delay: 2500,
      // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1281: {
        slidesPerView: 4,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 3,
        centeredSlides: false,
      },
      769: {
        slidesPerView: 2.5,
        centeredSlides: false,
      },
      641: {
        slidesPerView: 2,
        centeredSlides: false,
      },
      576: {
        slidesPerView: 1.5,
        centeredSlides: false,
      },
      319: {
        centeredSlides: false,
        slidesPerView: 1.1,
      },
    }
  });
}